import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Autocomplete,
  TextField,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel
} from '@mui/material';
import React, { useState } from 'react';
import { useGetParticipant } from '../../hooks/useLoads';

const cleanCheckboxSx = {
  '&:hover': {
    backgroundColor: 'transparent'
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'transparent'
  },
  '& .MuiSvgIcon-root': {
    fontSize: 22,
    borderRadius: '4px'
  },
  '&.Mui-checked .MuiSvgIcon-root': {
    color: '#2c3e50'
  }
};

function SgbuildexParticipantDialog({ open, onClose, onConfirm, element, type }) {
  const { data: dataParticipant, isFetching } = useGetParticipant(element);

  const participants = dataParticipant?.data || [];

  const [participant, setParticipant] = useState(null);
  const [onBehalfOf, setOnBehalfOf] = useState([]);
  const [testRole, setTestRole] = useState(''); // radio value

  const handleParticipantChange = (event, value) => {
    setParticipant(value);
    setOnBehalfOf([]);
  };

  const handleCheckboxChange = (item) => (event) => {
    if (event.target.checked) {
      setOnBehalfOf((prev) => [...prev, item]);
    } else {
      setOnBehalfOf((prev) => prev.filter((selected) => selected.id !== item.id));
    }
  };

  const handleSubmit = () => {
    const payload = {
      test_role: testRole,
      participants: participant
        ? [
            {
              name: participant.name,
              id: participant.id
            }
          ]
        : [],
      on_behalf_of: onBehalfOf.map((item) => ({
        name: item.name,
        id: item.id
      }))
    };

    onConfirm(payload);
  };

  const isChecked = (id) => onBehalfOf.some((selected) => selected.id === id);

  const onBehalfList = participant?.on_behalf_of || [];

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Participant & On-Behalf Selection</DialogTitle>

      <DialogContent>
        <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 3 }}>
          {type === 'cct' && (
            <FormControl>
              <FormLabel sx={{ fontWeight: 600 }}>Concrete Cube Test Role</FormLabel>

              <RadioGroup value={testRole} onChange={(e) => setTestRole(e.target.value)}>
                <FormControlLabel value="Concrete Cube Test Laboratory" control={<Radio />} label="Concrete Cube Test Laboratory" />

                <FormControlLabel value="Concrete Cube Test Contractor" control={<Radio />} label="Concrete Cube Test Contractor" />
              </RadioGroup>
            </FormControl>
          )}

          {/* PARTICIPANT */}
          <Autocomplete
            options={participants}
            value={participant}
            loading={isFetching}
            onChange={handleParticipantChange}
            getOptionLabel={(option) => option.name || ''}
            renderInput={(params) => <TextField {...params} label="Participant" />}
          />

          {/* ON BEHALF OF */}
          {participant && (
            <Box>
              <Typography sx={{ mb: 1, fontWeight: 600 }}>On Behalf Of</Typography>

              <FormGroup>
                {onBehalfList.map((item) => (
                  <FormControlLabel
                    key={item.id}
                    control={<Checkbox sx={cleanCheckboxSx} checked={isChecked(item.id)} onChange={handleCheckboxChange(item)} />}
                    label={item.name}
                  />
                ))}
              </FormGroup>
            </Box>
          )}

          <Button
            onClick={handleSubmit}
            sx={{ mt: 2, fontWeight: 'bold' }}
            fullWidth
            variant="contained"
            disabled={!participant || onBehalfOf.length === 0}
          >
            SUBMIT
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default SgbuildexParticipantDialog;
